module.exports = __webpack_public_path__ + "static/img/cloud.3821fcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/new_years_day/cloud.png
// module id = DI16
// module chunks = 1